module.exports = require('./dist/enum');
